import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { X } from "lucide-react";
import { Button } from "./ui/button";

export default function QRScannerModal({ open, onClose, onScanned }) {
  const containerRef = useRef(null);
  const scannerRef = useRef(null);
  const onScannedRef = useRef(onScanned);
  onScannedRef.current = onScanned;

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    let scannerInstance = null;

    const start = async () => {
      await new Promise((r) => setTimeout(r, 300));
      if (cancelled) return;

      const el = document.getElementById("qr-scanner-region-fullscreen");
      if (!el) return;

      try {
        const html5 = new Html5Qrcode("qr-scanner-region-fullscreen", { verbose: false });
        scannerInstance = html5;
        scannerRef.current = html5;

        await html5.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 250, height: 250 } },
          (decodedText) => {
            if (cancelled) return;
            const digits = String(decodedText).replace(/\D/g, "");
            if (digits.length >= 10) {
              cancelled = true;
              onScannedRef.current(digits.slice(-12));
            }
          },
          () => {}
        );
      } catch (e) {
        console.error("QRScanner start failed:", e);
      }
    };

    start();

    return () => {
      cancelled = true;
      const s = scannerInstance || scannerRef.current;
      if (s) {
        try {
          s.stop().then(() => s.clear()).catch(() => {});
        } catch (e) {
          console.error("QRScanner cleanup error", e);
        }
      }
      scannerRef.current = null;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black flex flex-col" data-testid="qr-scanner-fullscreen">
      <div className="relative flex-1 flex items-center justify-center">
        <div
          id="qr-scanner-region-fullscreen"
          ref={containerRef}
          className="w-full h-full"
          style={{ position: "absolute", inset: 0 }}
        />
        <div className="absolute inset-0 pointer-events-none flex items-center justify-center">
          <div className="w-[280px] h-[280px] border-4 border-white/50 rounded-2xl shadow-[0_0_0_9999px_rgba(0,0,0,0.5)]" />
        </div>
      </div>
      <div className="bg-black/90 backdrop-blur-sm p-6 text-center">
        <p className="text-white text-sm mb-4">
          Apunta la cámara al código QR del cliente
        </p>
        <Button
          variant="outline"
          onClick={onClose}
          className="w-full max-w-xs"
          data-testid="qr-scanner-close-btn"
        >
          <X className="w-4 h-4 mr-2" />
          Cancelar
        </Button>
      </div>
    </div>
  );
}
